<!-- 发展历程 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_about.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="发展历程" en="DEVELOPMENT HISTORY"></sub-title>
      </div>
      <div class="w1200 m">
        <div class="history-box">
          <img
            class="turn"
            src="../../assets/history_turn.png"
            alt=""
            @click="turnToStart"
          />
          <div
            class="history"
            @mousedown="mousedown"
            @mouseleave="mouseleave"
            @mouseup="mouseup"
            @mousemove="mousemove"
          >
            <div
              :class="{ line: true, active: activeIdx == idx }"
              v-for="(item, idx) in list"
              :key="item.id"
              @mouseenter="choseHistory(idx)"
            >
              <div class="point"></div>
              <div class="tip">
                <p>{{ item.historySlotTime }}</p>
                <p class="main">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="desc">{{ list[activeIdx] && list[activeIdx].content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
      list: [],
      activeIdx: 0,
      scrollDom: null, // 滚动dom
      isMouseDown: false, // 判断是否正在拖拽中
      startX: 0,
      scrollLeft: 0,
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {
    this.$api.getHistoryList().then((res) => {
      this.list = res.data;
      this.scrollDom = document.getElementsByClassName("history")[0];
    });
  },
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    choseHistory(idx) {
      this.activeIdx = idx;
    },
    mousedown(e) {
      this.isMouseDown = true;
      this.startX = e.pageX - this.scrollDom.offsetLeft;
      this.scrollLeft = this.scrollDom.scrollLeft;
    },
    mouseleave() {
      this.isMouseDown = false;
    },
    mouseup() {
      this.isMouseDown = false;
    },
    mousemove(e) {
      if (!this.isMouseDown) return;
      e.preventDefault();
      const x = e.pageX - this.scrollDom.offsetLeft;
      const walk = (x - this.startX) * 2; // 滚动速度调整
      this.scrollDom.scrollLeft = this.scrollLeft - walk;
    },
    turnToStart() {
      let timer = setInterval(() => {
        if (this.scrollDom.scrollLeft == 0) {
          clearInterval(timer);
        }
        this.scrollDom.scrollLeft -= 10;
      }, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/history_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;
  }
  .history-box {
    margin-bottom: 50px;
    position: relative;

    .turn {
      width: 35px;
      position: absolute;
      left: -70px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }
    .history {
      width: calc(1200px + (100vw - 1250px) / 2);
      height: 410px;
      overflow: auto;
      display: flex;
      align-items: center;
      cursor: grab;

      &::-webkit-scrollbar {
        display: none;
      }

      .line {
        flex-shrink: 0;
        width: 300px;
        position: relative;
        cursor: pointer;

        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 2px;
          background-color: #bbbdbe;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        &:nth-child(2n) {
          .tip {
            bottom: unset;
            top: 40px;

            &::after {
              top: unset;
              bottom: 100%;
              border-color: transparent transparent var(--bg) transparent;
            }
          }
        }

        .point {
          width: 16px;
          height: 16px;
          margin: 0 auto;
          background: #bbbdbe;
          border-radius: 50%;
          position: relative;
          z-index: 10;

          &::after {
            content: "";
            display: block;
            width: 19px;
            height: 19px;
            border-radius: 50%;
            border: 3px solid #bbbdbe;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .tip {
          --bg: #bbbdbe;
          width: 250px;
          height: 140px;
          color: #fff;
          text-align: center;
          background-color: var(--bg);
          position: absolute;
          left: 50%;
          bottom: 40px;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 25px;
          user-select: none;

          &::after {
            content: "";
            width: 0;
            height: 0;
            border-width: 12px 8px;
            border-color: var(--bg) transparent transparent transparent;
            border-style: solid;
            position: absolute;
            left: 50%;
            top: 100%;
            transform: translateX(-50%);
          }

          .main {
            white-space: pre-wrap;
          }
        }
      }
      .active {
        .point {
          background-color: $theme;

          &::after {
            border-color: $theme;
          }
        }
        .tip {
          --bg: #063c83;
        }
      }
    }
  }
  .desc {
    font-size: 18px;
    color: #5e5d5d;
    line-height: 30px;
    margin-bottom: 120px;
    white-space: pre-wrap;
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .m {
      display: flex;
      margin-bottom: 20px;
    }
    .history-box {
      width: 30%;
      flex-shrink: 0;

      .turn {
        display: none;
      }
      .history {
        width: 100%;
        padding-right: 10px;
        flex-direction: column;

        .line {
          width: 100%;
          height: 56px;

          &::after {
            content: "";
            width: 1px;
            height: 100%;
            right: 0;
            left: unset;
          }
          .point {
            width: 5px;
            height: 5px;
            position: absolute;
            right: -2px;
            top: 50%;
            transform: translateY(-50%);

            &::after {
              width: 7px;
              height: 7px;
            }
          }
          .tip {
            width: 84px;
            height: 20px;
            font-size: 12px;
            position: static;
            transform: none;
            position: absolute;
            left: 50%;
            top: 50% !important;
            transform: translate(-50%, -50%);

            &::after {
              display: none;
            }
            .main {
              display: none;
            }
          }
        }
      }
    }
    .desc {
      flex-grow: 1;
      font-size: 12px;
      padding: 10px;
      margin: 0 20px;
      background-color: rgba(19, 65, 120, 0.15);
    }
  }
}
</style>
